module.exports = __webpack_public_path__ + "bddc4bb18d18a21e41626e8d2485716e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Logos/MSH-Square_FR.png
// module id = 1561
// module chunks = 0